import { get } from "../api";

export const getSaasVendorsAnalysis = (id, formattedDate, params, signal) => {
  const url = `/api/v2/customers/${id}/saasvendoranalysis/${formattedDate}/`;
  return get(url, params, false, signal, true);
};